import React from 'react';
import { TruckLoanApproval } from '../../components/TruckLoanApplication/TruckLoanApproval';

const TruckLoanApprovalPage = () => {
    return <TruckLoanApproval />;
};

export { TruckLoanApprovalPage };
